<app-header [currentUser]="currentUser" *ngIf="currentUser"></app-header>

<div id="container">
  <app-sidebar
    [currentUser]="currentUser"
    [currentMenu]="currentMenu"
    *ngIf="currentUser"
  ></app-sidebar>

  <div id="content" [ngClass]="{ content: currentUser }">
    <div [ngClass]="{ container: currentUser }">
      <app-breadcrumbs *ngIf="currentUser"></app-breadcrumbs>

      <router-outlet></router-outlet>
      <div ng-view></div>
    </div>
  </div>
</div>
